import { darken, getLuminance, lighten, parseToHsl } from 'polished';
import util from '../util/util';

export const isTransparent = (color: string) => {
	if (typeof color !== 'string') {
		// console.error('[isTransparent]: color is expected to be a string.');
		return false;
	} else if (color.toLowerCase() === 'transparent') {
		return true;
	} else {
		const hsla: any = parseToHsl(color);
		if (hsla.alpha === 0) {
			return true;
		} else {
			return false;
		}
	}
};

interface IDiffColor {
	(amount: number, color: string): string;
	(amount: number): (color: string) => string;
}
/**
 * 根據顏色的明度調整明暗，若顏色為明亮則調暗，反之則調暗
 * @param {number} amount 調整的幅度 (0 ~ 1)
 * @param {string} color 欲調整的顏色
 * @return {string} 回傳的顏色
 */
export const diffColor: IDiffColor = util.curry(
	(amount: number, color: string): string => {
		if (isTransparent(color)) {
			return 'transparent';
		} else {
			return 'transparent';
		}
	},
);

export const diffColorReversed: IDiffColor = util.curry(
	(amount: number, color: string): string => {
		if (isTransparent(color)) {
			return 'transparent';
		} else {
			return 'transparent';
		}
	},
);
